import React, { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

const NotFoundPage = lazy(() => import('Components/NotFoundPage'));
const QCodeAccordion = lazy(() => import('Components/QCodeAccordion'));
const About = lazy(() => import('Sections/About'));
const ContactForm = lazy(() => import('Sections/ContactForm'));
const HamRadioBandPlan = lazy(() => import('Sections/HamRadioBandPlan'));
const HamRadioEmulator = lazy(() => import('Sections/HamRadioEmulator'));
const HamRadioQuiz = lazy(() => import('Sections/HamRadioQuiz'));
const Home = lazy(() => import('Sections/Home'));
const MeshtasticWeatherStation = lazy(() => import('Sections/MeshtasticWeatherStation'));
const MorseCodeTrainer = lazy(() => import('Sections/MorseCodeTrainer'));
const NatoTrainer = lazy(() => import('Sections/NatoTrainer'));
const HamRadioLearning = lazy(() => import('Sections/HamRadioLearning'));
const BlogIndexPage = lazy(() => import('features/blog/BlogIndexPage'));
const BlogPage = lazy(() => import('features/blog/components/BlogPage'));
const ImageGalleryPage = lazy(() => import('features/gallery/ImageGalleryPage'));

function RouteFallback() {
  return <div style={{ minHeight: '40vh' }} aria-busy="true" />;
}

export default function AppRoutes() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<BlogIndexPage />} />
        <Route path="/blog/:slug" element={<BlogPage />} />
        <Route path="/contact-form" element={<ContactForm />} />
        <Route path="/ham-radio-band-plan" element={<HamRadioBandPlan />} />
        <Route path="/ham-radio-emulator" element={<HamRadioEmulator />} />
        <Route path="/ham-radio-license-quiz" element={<HamRadioQuiz />} />
        <Route path="/ham-radio-q-codes" element={<QCodeAccordion />} />
        <Route path="/meshtastic-weather-station" element={<MeshtasticWeatherStation />} />
        <Route path="/morse-code-trainer" element={<MorseCodeTrainer />} />
        <Route path="/Nato-phonetic-alphabet-trainer" element={<NatoTrainer />} />
        <Route path="/react-image-gallery" element={<ImageGalleryPage />} />
        <Route path="/ham-radio-learning" element={<HamRadioLearning />} />
        <Route path="/study-resources" element={<HamRadioLearning />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
